import {enablePageLoad, disablePageLoad, addErrorMessage} from './feedback';
import {MergeAction, createMergeAction} from './base';
import {substitute} from './core/strings';
import {V1UsersResource} from './services';
import moment from 'moment';

// initial language that should be replaced with valid lang on page load
export const LANG_NONE = '';
export const LANG_EN_GB = 'en-gb';
export const LANG_DE_DE = 'de-de';
export const LANG_FR_FR = 'fr-fr';
export const LANG_EL_GR = 'el-gr';
export const LANG_SL_SL = 'sl-sl';
export const LANG_SV_SE = 'sv-se';
export const LANG_HE_IL = 'he-il';
export const LANG_CS_CZ = 'cs-cz';
export const LANG_RO_RO = 'ro-ro';
export const LANG_ZH_HANS = 'zh-hans';

export interface Language {
    code: string;
    displayName: string;
}

export let AvailableLanguages: {[key: string]: Language} = {};

AvailableLanguages[LANG_EN_GB] = {
    code: LANG_EN_GB,
    displayName: 'English'
};
AvailableLanguages[LANG_CS_CZ] = {
    code: LANG_CS_CZ,
    displayName: 'Czechia'
};
AvailableLanguages[LANG_DE_DE] = {
    code: LANG_DE_DE,
    displayName: 'Deutsch'
};
AvailableLanguages[LANG_FR_FR] = {
    code: LANG_FR_FR,
    displayName: 'Français'
};
AvailableLanguages[LANG_EL_GR] = {
    code: LANG_EL_GR,
    displayName: 'Ελλάδα'
};
AvailableLanguages[LANG_ZH_HANS] = {
    code: LANG_ZH_HANS,
    displayName: '简体中文'
};
AvailableLanguages[LANG_RO_RO] = {
    code: LANG_RO_RO,
    displayName: 'Română'
};
AvailableLanguages[LANG_SL_SL] = {
    code: LANG_SL_SL,
    displayName: 'Slovenski'
};
AvailableLanguages[LANG_SV_SE] = {
    code: LANG_SV_SE,
    displayName: 'Svenska'
};
AvailableLanguages[LANG_HE_IL] = {
    code: LANG_HE_IL,
    displayName: 'עִברִית'
};


//////////////////
// Text Keys
const TEXT_CHANGING_LANG = 'language_changing';
const TEXT_CANNOT_LOAD_LANGUAGE = 'language_cannot_load';
export const TEXT_FOOTER_POWERED_BY = 'footer_powered_by';
export const TEXT_REGISTER_LINK_NEW_GATEWAY = 'register_new_gateway';
export const TEXT_FOOTER_TERMS_OF_SERVICE = 'footer_terms_of_service';
export const TEXT_FOOTER_PRIVACY_POLICY = 'footer_privacy_policy';
export const TEXT_ERROR_ALARM_COUNT = 'error_cannot_update_alarm_count';
export const TEXT_ERROR_CALIBRATION_START = 'error_cannot_start_calibration_process';
export const TEXT_ERROR_CALIBRATION_STATUS = 'error_cannot_load_calibration_status';
export const TEXT_ERROR_CALIBRATION_UNITS = 'error_cannot_load_calibration_units';
export const TEXT_ERROR_CALIBRATION_NOT_ALLOWED = 'error_calibration_cannot_assign_unit';
export const TEXT_ERROR_IN_LOADING_READINGS = 'error_loading_readings';
export const TEXT_ERROR_COUNTRIES = 'error_cannot_load_countries';
export const TEXT_ERROR_GATEWAYS = 'error_cannot_load_gateways';
export const TEXT_ERROR_LOGOUT = 'error_cannot_logout';
export const TEXT_ERROR_PREMISES = 'error_cannot_load_premises';
export const TEXT_ERROR_PREMISES_SUBSCRIBE = 'error_cannot_subscribe_to_premises';
export const TEXT_ERROR_NO_READINGS = 'error_no_readings';
export const TEXT_ERROR_REGISTRATION_CODE_NO_SIM_DETAILS = "error_registration_code_no_sim_details";
export const TEXT_ERROR_REGISTRATION_CODE_NO_GATEWAY_COMMS = "error_registration_code_no_gateway_comms";
export const TEXT_ERROR_REGISTRATION_CODE_GATEWAY_EXISTS = "error_registration_code_gateway_exists";
export const TEXT_ERROR_REGISTRATION_CODE_INTERNAL_ERROR = "error_registration_code_internal_error";
export const TEXT_ERROR_REGISTRATION_CODE_INVALID_ICCID = "error_registration_code_invalid_iccid";
export const TEXT_PAGINATION_FIRST = 'pagination_first';
export const TEXT_PAGINATION_NEXT = 'pagination_next';
export const TEXT_PAGINATION_PREVIOUS = 'pagination_previous';
export const TEXT_PAGINATION_LAST = 'pagination_last';
export const TEXT_HEADER_STORE = 'header_store';
export const TEXT_HEADER_CABINETS = 'header_cabinets';
export const TEXT_CARD_NO_OF_UNITS = 'card_no_of_units';
export const TEXT_CARD_NO_OF_ALARMS = 'card_no_of_alarms';
export const TEXT_CALIBRATION_SELECT_PREMISES = 'calibration_select_premises';
export const TEXT_CALIBRATION_SELECT_NO_PREMISES_AVAILABLE = 'calibration_select_no_premises_available';
export const TEXT_CALIBRATION_BUTTON_START = 'calibration_button_start';
export const TEXT_CALIBRATION_BUTTON_RETRY = 'calibration_button_retry';
export const TEXT_CALIBRATION_BUTTON_CANCEL = 'calibration_button_cancel';
export const TEXT_CALIBRATION_SELECT_CALIBRATION_UNIT = 'calibration_select_calibration_unit';
export const TEXT_CALIBRATION_SELECT_NO_UNITS_AVAILABLE = 'calibration_select_no_units_available';
export const TEXT_CALIBRATION_BUTTON_RESET = 'calibration_button_reset';
export const TEXT_CALIBRATION_TABLE_HEAD_UNIT_PREMISES = 'calibration_table_head_unit_premises';
export const TEXT_CALIBRATION_TABLE_HEAD_UNIT_CALIBRATION = 'calibration_table_head_unit_calibration';
export const TEXT_CALIBRATION_TABLE_HEAD_STATUS = 'calibration_table_head_status';
export const TEXT_TOOLTOP_EDIT_UNIT = 'tooltip_edit_unit';
export const TEXT_TOOLTIP_VIEW_ALARMS = 'tooltip_view_alarms';
export const TEXT_TOOLTIP_SUBSCRIBE = 'tooltip_subscribe';
export const TEXT_TOOLTIP_ADD_TO_DASHBOARD = 'tooltip_add_to_dashboard';
export const TEXT_TOOLTIP_REMOVE_FROM_DASHBOARD = 'tooltip_remove_from_dashboard';
export const TEXT_TOOLTIP_EXPORT = 'tooltip_export';
export const TEXT_FILTER_RESET = 'filter_reset';
export const TEXT_FILTER_LOCATION_LOADING = 'filter_location_loading';
export const TEXT_FILTER_COUNTRY_DEFAULT = 'filter_location_country_default';
export const TEXT_FILTER_REGION_DEFAULT = 'filter_location_region_default';
export const TEXT_MENU_SETTINGS = 'menu_settings';
export const TEXT_MENU_ADMIN = 'menu_admin';
export const TEXT_MENU_KEYCLOAK = 'menu_keycloak';
export const TEXT_MENU_LOGOUT = 'menu_logout';
export const TEXT_LIVE_DATA = 'live_data';
export const TEXT_TODAY_DATA = 'today_data';
export const TEXT_YESTERDAY_DATA = 'yesterday_data';
export const TEXT_7DAY_DATA = '7day_data';
export const TEXT_TITLE_REGISTER_ICCID = 'register_iccid_title';
export const TEXT_TITLE_REGISTER_PREMISES = 'register_premises_title';
export const TEXT_FORM_ERROR_INVALID_DEVICE_ID = 'form_error_invalid_device_id';
export const TEXT_FORM_ERROR_TOO_SHORT = 'form_error_too_short';
export const TEXT_FORM_ERROR_TOO_LONG = 'form_error_too_long';
export const TEXT_REGISTER_FORM_SUBMIT = 'register_form_submit';
export const TEXT_FORM_ERROR_INVALID_EMAIL = 'form_error_invalid_email';
export const TEXT_FORM_ERROR_INVALID_ICCID = 'form_error_invalid_iccid';
export const TEXT_FORM_ERROR_INVALID_MOBILE = 'form_error_invalid_mobile';
export const TEXT_ICCID_FORM_LABEL_ICCID = 'iccid_form_label_iccid';
export const TEXT_REGISTER_FORM_LABEL_GATEWAY_ID = 'register_form_label_gateway_id';
export const TEXT_REGISTER_FORM_LABEL_NAME = 'register_form_label_name';
export const TEXT_REGISTER_FORM_LABEL_ADDRESS1 = 'register_form_label_address1';
export const TEXT_REGISTER_FORM_LABEL_ADDRESS2 = 'register_form_label_address2';
export const TEXT_REGISTER_FORM_LABEL_REGION = 'register_form_label_region';
export const TEXT_REGISTER_FORM_LABEL_COUNTRY = 'register_form_label_country';
export const TEXT_REGISTER_FORM_LABEL_POSTCODE = 'register_form_label_postcode';
export const TEXT_REGISTER_FORM_LABEL_SUBSCRIBE_CHECK = 'register_form_label_subscribe_check';
export const TEXT_REGISTER_FORM_SELECT_REGION = 'register_form_select_region';
export const TEXT_REGISTER_FORM_SELECT_COUNTRY = 'register_form_select_country';
export const TEXT_REGISTER_FORM_CHECKBOX_SUBSCRIBE = 'register_form_checkbox_subscribe';
export const TEXT_REGISTER_ERROR_UNABLE_TO_REGISTER = 'register_error_unable_to_register';
export const TEXT_REGISTER_UNAUTHORIZED = 'register_unauthorized';
export const TEXT_REGISTER_UNKNOWN_ERROR = 'register_unknown_error';
export const TEXT_MODAL_TITLE_EXPORT = 'modal_title_export';
export const TEXT_MODAL_BUTTON_CANCEL = 'modal_button_cancel';
export const TEXT_MODAL_BUTTON_CLOSE = 'modal_button_close';
export const TEXT_MODAL_BUTTON_DOWNLOAD = 'modal_button_download';
export const TEXT_MODAL_BUTTON_RETRY = 'modal_button_retry';
export const TEXT_MODAL_EXPORT_FILE_GENERATED = 'modal_export_file_generated';
export const TEXT_MODAL_EXPORT_DATERANGE = 'modal_export_daterange';
export const TEXT_MODAL_EXPORT_CUSTOM = 'modal_export_custom';
export const TEXT_MODAL_EXPORT_FROM = 'modal_export_from';
export const TEXT_MODAL_EXPORT_TO = 'modal_export_to';
export const TEXT_MODAL_EXPORT_ERROR = 'modal_export_error';
export const TEXT_MODAL_EXPORT_SENSORS_SEPARATOR = 'modal_export_sensors_separator';
export const TEXT_MODAL_BUTTON_CONTINUE = 'modal_button_continue';
export const TEXT_MODAL_BUTTON_SAVE = 'modal_button_save';
export const TEXT_MODAL_BUTTON_SUBMIT = 'modal_button_submit';
export const TEXT_MODAL_SUBSCRIBE_ERROR = 'modal_export_error';
export const TEXT_MODAL_TITLE_SUBSCRIBE = 'modal_title_subscribe';
export const TEXT_MODAL_TITLE_CALIBRATION_CANCEL = 'modal_title_calibration_cancel';
export const TEXT_MODAL_CALIBRATION_CANCEL_LABEL_CANCEL = 'modal_title_calibration_cancel_label_cancel';
export const TEXT_CALIBRATION_UNIT_STATUS_IN_PROGRESS = 'calibration_unit_status_inprogress';
export const TEXT_CALIBRATION_UNIT_STATUS_PASS = 'calibration_unit_status_pass';
export const TEXT_CALIBRATION_UNIT_STATUS_ERROR = 'calibration_unit_status_error';
export const TEXT_CALIBRATION_METADATA_OFFSET_LABEL = 'calibration_unit_status_offset';
export const TEXT_CALIBRATION_UNIT_STATUS_FAIL = 'calibration_unit_status_fail';
export const TEXT_CALIBRATION_UNIT_STATUS_CANCELLED = 'calibration_unit_status_cancelled';
export const TEXT_MODAL_SUBSCRIBE_LABEL_MOBILE = 'modal_subscribe_mobile_label';
export const TEXT_MODAL_SUBSCRIBE_LABEL_EMAIL = 'modal_subscribe_email_label';
export const TEXT_MODAL_SUBSCRIBE_INSTRUCTION_LINE1 = 'modal_subscribe_instructions_line1';
export const TEXT_MODAL_SUBSCRIBE_INSTRUCTION_LINE2 = 'modal_subscribe_instructions_line2';
export const TEXT_MODAL_EXPORT_REPORT_TYPE_DATA = 'modal_export_type_data';
export const TEXT_MODAL_EXPORT_REPORT_TYPE_DATA_DUMP = 'modal_export_type_data_dump';
export const TEXT_MODAL_EXPORT_REPORT_TYPE_HACCP = 'modal_export_type_haccp';
export const TEXT_MODAL_EXPORT_REPORT_PLACEHOLDER = 'modal_export_type_placeholder';
export const TEXT_MODAL_EXPORT_SENSOR_PLACEHOLDER = 'modal_export_sensor_placeholder';
export const TEXT_MODAL_EXPORT_SENSOR_NO_RESULTS = 'modal_export_sensor_no_results';
export const TEXT_MODAL_EXPORT_DATA_INTERVAL_LABEL = 'modal_export_data_interval_label';
export const TEXT_INTERVAL_NONE = 'interval_none';
export const TEXT_INTERVAL_ONE_HOUR = 'interval_one_hour';
export const TEXT_DATE_RANGE_TODAY = 'date_range_today';
export const TEXT_DATE_RANGE_YESTERDAY = 'date_range_yesterday';
export const TEXT_DATE_RANGE_LAST7DAYS = 'date_range_last7days';
export const TEXT_DAY_OF_WEEK_ABBREV_MO = 'day_of_week_abbrev_mo';
export const TEXT_DAY_OF_WEEK_ABBREV_TU = 'day_of_week_abbrev_tu';
export const TEXT_DAY_OF_WEEK_ABBREV_WE = 'day_of_week_abbrev_we';
export const TEXT_DAY_OF_WEEK_ABBREV_TH = 'day_of_week_abbrev_th';
export const TEXT_DAY_OF_WEEK_ABBREV_FR = 'day_of_week_abbrev_fr';
export const TEXT_DAY_OF_WEEK_ABBREV_SA = 'day_of_week_abbrev_sa';
export const TEXT_DAY_OF_WEEK_ABBREV_SU = 'day_of_week_abbrev_su';
export const TEXT_MONTH_JANUARY = 'month_january';
export const TEXT_MONTH_FEBRUARY = 'month_february';
export const TEXT_MONTH_MARCH = 'month_march';
export const TEXT_MONTH_APRIL = 'month_april';
export const TEXT_MONTH_MAY = 'month_may';
export const TEXT_MONTH_JUNE = 'month_june';
export const TEXT_MONTH_JULY = 'month_july';
export const TEXT_MONTH_AUGUST = 'month_august';
export const TEXT_MONTH_SEPTEMBER = 'month_september';
export const TEXT_MONTH_OCTOBER = 'month_october';
export const TEXT_MONTH_NOVEMBER = 'month_november';
export const TEXT_MONTH_DECEMBER = 'month_december';
export const TEXT_NAVIGATION_ALARMS = 'navigation_alarms';
export const TEXT_NAVIGATION_CABINETS = 'navigation_cabinets';
export const TEXT_NAVIGATION_CALIBRATION = 'navigation_calibration';
export const TEXT_NAVIGATION_CONFIGURATION = 'navigation_configuration';
export const TEXT_NAVIGATION_DASHBOARD = 'navigation_dashboard';
export const TEXT_NAVIGATION_MANAGE_ALARMS = 'navigation_manage_alarm';
export const TEXT_NAVIGATION_STORES = 'navigation_stores';
export const TEXT_NO_READINGS = 'no_readings';
export const TEXT_SUBSCRIBE = 'subscribe';
export const TEXT_UNSUBSCRIBE = 'unsubscribe';
export const TEXT_USER_EMAIL = 'text_user_email';
export const TEXT_DEFAULT_TEMPERATURE_UM = 'text_default_temperature_um';
export const TEXT_TIMEZONE = 'timezone_label';
export const TEXT_TIME = 'time';
export const TEXT_LABEL_MOBILE = 'text_mobile_label';
export const TEXT_TITLE_USER_SETTINGS = 'user_settings_title';
export const TEXT_USER_SELECT_LANGUAGE = 'user_language';
export const TEXT_CHANGE_PASSWORD = 'text_password_change';
export const TEXT_CONFIRM_PASSWORD = 'text_password_confirm';
export const TEXT_CONFIRM_PASSWORD_ERROR = 'text_password_confirm_error';
export const TEXT_CURRENT_PASSWORD = 'text_password_current';
export const TEXT_NEW_PASSWORD = 'text_password_new';
export const TEXT_NEW_PASSWORD_ERROR = 'text_password_new_error';
export const TEXT_SAMPLE_EMAIL = 'text_sample_email';
export const TEXT_SAMPLE_MOBILE = 'text_sample_mobile';
export const TEXT_SUCCESS = 'success';
export const TEXT_DISABLED = 'disabled';
export const TEXT_OFFLINE = 'offline';
export const TEXT_OPEN = 'open';
export const TEXT_CLOSED = 'closed';
export const TEXT_CONFIGURATION = 'configuration';
export const TEXT_NA = "na";
export const TEXT_LOCALITY = 'locality';
export const TEXT_RESET_ZOOM = 'reset_zoom';
export const TEXT_COOKIE_BANNER_HEAD = 'text_cookie_banner_head';
export const TEXT_COOKIE_BANNER_CONTENT = 'text_cookie_banner_content';
export const TEXT_COOKIE_BANNER_POLICY_LINK = 'text_cookie_banner_policy_link';
export const TEXT_COOKIE_BANNER_CLOSE = 'text_cookie_banner_close';

/**
 * Resource for loading user language.
 */
export class TextResource extends V1UsersResource {
    constructor() {
        super(V1UsersResource.TEXT);
    }
}

export let TextAPI = new TextResource();


/**
 * Sets the language code and function for returning specific language text by
 * the unique language text key.
 */
function setLanguage(langCode: string, text: any) : MergeAction {
    return createMergeAction('set_language', {
        data: {
            language: langCode,
            textForKey: function(key: string, substitutions?: Object) {
                let value = text[key] || key;
                if (substitutions) {
                    value = substitute(value, substitutions);
                }
                return value;
            }
        }
    });
}

/**
 * Thunk action that loads the text for the language code given.
 */
export function loadLanguage(langCode: string, block = true) : Function {
    return function (dispatch) {
        // set global locale in MomentJS
        let momentLangCode = langCode === 'zh-hans' ? 'zh-cn' : langCode;
        moment.locale(momentLangCode);
        dispatch(enablePageLoad(TEXT_CHANGING_LANG));
        return TextAPI.list({locale: langCode}).then(function(response) {
            dispatch(setLanguage(langCode, response.data));
            if (block) {
                dispatch(disablePageLoad());
            }
        }).catch(function() {
            dispatch(addErrorMessage(TEXT_CANNOT_LOAD_LANGUAGE));
            if (block) {
                dispatch(disablePageLoad());
            }
        });
    };
}

export const UM_CELSIUS = '°C';
export const UM_FAHRENHEIT = '°F';
export const TEXT_CELSIUS = 'text_celsius';
export const TEXT_FAHRENHEIT = 'text_fahrenheit';
export interface UnitOfMeasurement {
    code: string;
    displayName: string;
}

export let AvailableUnitsOfMeasurement: {[key: string]: UnitOfMeasurement} = {};

AvailableUnitsOfMeasurement[UM_CELSIUS] = {
    code: UM_CELSIUS,
    displayName: TEXT_CELSIUS
};
AvailableUnitsOfMeasurement[UM_FAHRENHEIT] = {
    code: UM_FAHRENHEIT,
    displayName: TEXT_FAHRENHEIT
};
